import Vue from 'vue';
import Vuex from 'vuex';
import user from "./user/index";
import common from "./common/index";
import drawers from "./drawers/index";
import currentnav from "./currentnav/index";
Vue.use(Vuex);
var store = new Vuex.Store({
  modules: {
    user: user,
    currentnav: currentnav,
    common: common,
    drawers: drawers
  }
});

if (process.env.DEV && module.hot) {
  module.hot.accept(['./user', './currentnav', './drawers', './common'], function () {
    var newUser = require("./user/index").default;

    store.hotUpdate({
      modules: {
        user: newUser
      }
    });

    var newCurrentnav = require("./currentnav/index").default;

    store.hotUpdate({
      modules: {
        currentnav: newCurrentnav
      }
    });

    var newDrawers = require("./drawers/index").default;

    store.hotUpdate({
      modules: {
        drawers: newDrawers
      }
    });

    var newCommon = require("./common/index").default;

    store.hotUpdate({
      modules: {
        common: newCommon
      }
    });
  });
}

export default store;